import {
	DocumentUpload,
	IncidentLog,
	SearchIncidentsResult,
	type Id,
	type Nullable,
	type SearchIncidentsRequest,
} from "@/models"
import { SARLogHttpService } from "@/services/httpService"

export class IncidentsService extends SARLogHttpService {
	constructor() {
		super("/api/incident-logs")
	}

	async create(log: IncidentLog, documentsToUpload: File[]): Promise<IncidentLog> {
		const formData = new FormData()

		log.incidentDocuments = []
		formData.set("incidentData", JSON.stringify(log))

		for (const document of documentsToUpload) {
			formData.append("documents", document)
		}

		return await this.returning(IncidentLog).post("", formData)
	}

	async getById(id: Id): Promise<Nullable<IncidentLog>> {
		return await this.returning(IncidentLog.nullable()).get(`${id}`)
	}

	async search(request: SearchIncidentsRequest): Promise<SearchIncidentsResult> {
		return await this.returning(SearchIncidentsResult).post("search", request)
	}

	async connect(incidentId: Id): Promise<string> {
		return await this.returning(String).post(`${incidentId}/connect`, undefined)
	}

	async uploadDocuments(incidentId: Id, documentsToUpload: File[]): Promise<DocumentUpload[]> {
		const formData = new FormData()

		for (const document of documentsToUpload) {
			formData.append("documents", document)
		}

		return await this.returning(DocumentUpload.array()).post(`${incidentId}/documents`, formData)
	}
}
